// extracted by mini-css-extract-plugin
export default {"categoryButton":"CategoryButton_categoryButton__DiDIG"};